var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"normal",class:{ dark: _vm.$vuetify.theme.dark, disable: _vm.disable },style:(_vm.compoutedStyle),on:{"click":_vm.clickButton}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }